export const infoText = {
  fontSize: 18,
};

export const infoTextBold = {
  ...infoText,
  fontWeight: "bold",
  marginTop: 4,
};
